export default "/images/856478774dc837c16e745ee80fbf57d2.avif";